<template>
  <div v-if="countries.length && basins.length" class="h-100">
    <Header></Header>
    <Home v-if="assessment.step == steps[0]"></Home>
    <Main v-else></Main>
  </div>
</template>

<script>
import { CenterScale, defaultFocusModel } from "vue-niney";
import Header from "@/components/layout/Header.vue";
import Home from "@/views/Home.vue";
import Main from "@/views/Main.vue";
import { assessment, steps } from "@/services/assessment-model.js";
import {
  loadBaseEntities,
  countries,
  basins,
  crops,
  countryCropsByCountryLoader,
  countryCropsByCropLoader,
  basinCropsByBasinLoader,
  basinCropsByCropLoader,
  countryBasinCropsLoader
} from "@/services/entity-model.js";
import * as _ from 'lodash';

export default {
  name: "App",
  components: {
    Header,
    Home,
    Main
  },
  data() {
    return {
      countries: countries,
      basins: basins,
      crops: crops,
      assessment: assessment,
      steps: steps
    };
  },
  created: function() {
    defaultFocusModel.minScale = 3466752.130657345;
    defaultFocusModel.setCenterScale(new CenterScale(0, 3000000, 110936068.18103503));

    loadBaseEntities();
    countryCropsByCropLoader.load(100001);
    basinCropsByCropLoader.load(100001);
  },
  methods: {
    updateAssessmentByUrl: function() {
      if ((countries.length == 0) || (basins.length == 0) || (crops.length == 0)) {
        return;
      }
      
      const params = Object.values(this.$route.params);
      if (params.length > 0) {
        assessment.setAssessmentType(params[0]);
        
        if (params.length > 1) {
          if (params[1].indexOf("~") == -1) {
            params.splice(1, null, null);
          }
          
          const routeMap = { scope: 0, accounting: 1, sustainability: 2, response: 3 };
          assessment.setStep(routeMap[params[2]]);
          
          if (params[1] != null) {
            var ids = params[1].substr(1).split("~");
            if (assessment.assessmentType.name == "countries") {
                assessment.countriesOrBasins = countries.filter(val => _.indexOf(ids, val.iso3Code) > -1);
            } else {
                ids = _.map(ids, (id) => parseInt(id));
                assessment.countriesOrBasins = basins.filter(val => _.indexOf(ids, val.basinID) > -1);
            }
          }
          
          if (params.length > 3) {
            assessment.setViewType(params[3]);
            
            if (params.length > 4) {
              assessment.setViewColor(params[4]);
              
              if (params.length > 5) {
                assessment.setCrop(parseInt(params[5]));
              }
            }
            
          }
        }
      }
    },
    updateUrlByAssessment: function() {
      let route = "/";
      if (assessment.assessmentType != null) {
        route += assessment.assessmentType.name;
        if (assessment.countriesOrBasins.length > 0) {
          route += "/";
          if (assessment.assessmentType.name == "basins") {
            for (const basin of assessment.countriesOrBasins) {
              route += "~" + basin.basinID;
            }
          } else {
            for (const country of assessment.countriesOrBasins) {
              route += "~" + country.iso3Code;
            }
          }
        }
        route += "/" + assessment.step.name;
        if (assessment.viewType != null) {
          route += `/${assessment.viewType.name}/${assessment.viewColor}`;
          if (assessment.crop != null) {
            route += `/${assessment.crop.cropID}`;
          }
        }
      }
      
      if (assessment.assessmentType != null) {
        this.$router.push(route);
      }
    }
  },
  watch: {
    "assessment.assessmentType": function() {
      this.updateUrlByAssessment();
    },
    "assessment.step": function() {
      this.updateUrlByAssessment();
    },
    "assessment.viewType": function() {
      this.updateUrlByAssessment();
    },
    "assessment.viewColor": function() {
      this.updateUrlByAssessment();
    },
    countries: {
      handler: function() {
        this.updateAssessmentByUrl();
      },
      deep: true
    },
    basins: {
      handler: function() {
        this.updateAssessmentByUrl();
      },
      deep: true
    },
    crops: {
      handler: function() {
        this.updateAssessmentByUrl();
      },
      deep: true
    },
/*    $route: function() {
      this.updateAssessmentByUrl();
    },*/
    "assessment.countriesOrBasins": function(val, previousVal) {
      this.updateUrlByAssessment();
      
      if (val.length > 0) {
        if (assessment.assessmentType.name === 'countries') {
          countryCropsByCountryLoader.load(val[0].countryID);
        }
        if (assessment.assessmentType.name === 'basins') {
          basinCropsByBasinLoader.load(val[0].basinID);
        }
      }
      
      const urlParams = {countryID: null, basinID: null, cropID: (assessment.crop != null)? assessment.crop.cropID: 100001};
      const idPropertyName = assessment.assessmentType.idPropertyName;
      urlParams[idPropertyName] = val.map(o => o[idPropertyName]).sort().join(",");
      const previousIds = previousVal.map(o => o[idPropertyName]).sort().join(",");
      if (urlParams[idPropertyName] != previousIds) {
        countryBasinCropsLoader.load(urlParams.countryID, urlParams.basinID, urlParams.cropID);
      }
    },
    "assessment.crop": function(val) {
      this.updateUrlByAssessment();
      
      countryCropsByCropLoader.load(val.cropID);
      basinCropsByCropLoader.load(val.cropID);
      
      const urlParams = {countryID: null, basinID: null, cropID: val.cropID};
      const idPropertyName = assessment.assessmentType.idPropertyName;
      urlParams[idPropertyName] = assessment.countriesOrBasins.map(o => o[idPropertyName]).sort().join(",");
      countryBasinCropsLoader.load(urlParams.countryID, urlParams.basinID, urlParams.cropID);
    }
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "rubrikregular";
  src: url("./assets/fonts/rubrik_regular-webfont.eot");
  src: url("./assets/fonts/rubrik_regular-webfont.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/rubrik_regular-webfont.woff") format("woff"), url("./assets/fonts/rubrik_regular-webfont.ttf") format("truetype"), url("./assets/fonts/rubrik_regular-webfont.svg#rubrik_regularregular") format("svg");
  font-weight: normal;
  font-style: normal;
}

html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  color: #301948;
  overflow-x: hidden;
}

table {
    font-size: 15px;
}

.h-rest {
    height: calc(100% - 60px);
}

.lottie {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 99999;
    border: solid 4px #edebe5;
    border-radius: 54px;
    background-color: #6db3a2;
    transform: translate(-50%, -50%);
}

.introduction-text {
  margin: 20px 0 30px 0;
  font-family: "rubrikregular";
  font-size: 18px;
  line-height: 27px;
}

.chart-axis-label {
  font-family: Arial, Helvetica, sans-serif;
  text-align: right;
}

.chart-tooltip {
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  padding: 5px;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);

  p {
    margin-bottom: 8px;
  }
}

.multiselect__option {
  line-height: 13px;
  min-height: 30px;
  font-size: 13px;
  &::after {
    line-height: 30px;
    min-height: 30px;
    font-size: 13px;
  }
}

.multiselect {
    &__tag {
            background-color: #009bd1;
    }
}

.wt-container
{
    height: 100%;
    padding: 0 8%;
    margin: 0 auto;
    overflow-y: scroll;
    // background: #cccccc; /* Old browsers */
    // background: -moz-linear-gradient(top,  #cccccc 0%, #ececec 100%); /* FF3.6-15 */
    // background: -webkit-linear-gradient(top,  #cccccc 0%,#ececec 100%); /* Chrome10-25,Safari5.1-6 */
    // background: linear-gradient(to bottom,  #cccccc 0%,#ececec 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    // filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#cccccc', endColorstr='#ececec',GradientType=0 ); /* IE6-9 */
}

.button {
    cursor: pointer;
    background-color: #009bd1;
    color: white;
    padding: 10px 40px;
    border: none;
    border-radius: 8px;
    &:focus {
        outline: 0;
    }

    &:hover {
      background-color: #41b883;
    }
}

.content {
    position: relative;
}

a {
  &:hover {
    color: #41b883;
  }
}
</style>
